import { Observable } from "rxjs/Observable";
import { whenConnected } from "../helpers/subscription";
import { StompActionskeys } from "../stomp-broker";
import { ActionsTypes, addTMValue } from "./actions";
export function getQueueUrl({ tag, satellite }) {
    return `/topic/focus/notification/telemetry/${tag}/${satellite}`;
}
const mapMessage2Actions = (message) => Observable.of(addTMValue(message.payload));
export const listenToTMFeedEpic = (actions$, _, { stomp }) => whenConnected(actions$, ActionsTypes.SUBSCRIBE).mergeMap(([_, action]) => stomp
    .subscribe(getQueueUrl(action.payload))
    .mergeMap(mapMessage2Actions)
    .takeUntil(actions$.ofType(StompActionskeys.DISCONNECTED).take(1)));
//# sourceMappingURL=middleware.js.map